<template>
  <div id="app">
    <router-view />
    <div class="text-center">
      <footer class="h-10 text-white mt-5">
        <div>
          <div class="flex justify-center mt-2">
            <phone-call-icon />
            <div class="ml-4 text-md">
              <a href="tel:+8801714053213">01714053213</a>
            </div>
          </div>
          <div class="flex justify-center mt-2">
            <mail-icon />
            <div class="ml-4 text-md">
              <a href="mailto:tasfia.upskill@gmail.com"
                >tasfia.upskill@gmail.com</a
              >
            </div>
          </div>
        </div>
      </footer>
    </div>
  </div>
</template>
<script>
export default {
  mounted() {},
}
</script>
<style>
.ck.ck-button .ck.ck-tooltip {
  display: none;
}
.z-100 {
  z-index: 100;
}
</style>
